import { AOOLIA, DRAW, HELLOICE, STORAGE_KEY } from '@/constant/constant';
import { isCommonSimpleOrTest, isXikeOrTest } from '@/utils/platform';
import { shopify, xike } from '@/constant/company';
import { companyUUID, debounce } from '@/service/api';
import { matchUrlParts } from '@/service/strategy/logic';
import { formEventV2 } from '@/service/formEventV2';
import { safeJsonParse } from '@/utils/safeJsonParse';
import { getLocal, getSession, setLocal, removeLocal } from '@/utils/storage';
import { sanitizeHtml } from '@/utils/safeHtml';
import { catchLog } from '@/utils/catchLog';

export function showBanner() {
  let cartxBanner = getLocal(STORAGE_KEY.CARTX_BANNER);
  let banner = document.querySelector('.cartx-banner');
  if (cartxBanner && !banner) {

    // 获取cartxBanner的弹窗id
    const id = cartxBanner.match(/id="([^"]+)"/)?.[1];
    // 读取本地配置
    const popupConfig = safeJsonParse<{ rets?: any[] }>(
      getSession(STORAGE_KEY.POPUP),
      { rets: [] }
    );
    const config = popupConfig.rets?.find((item: any) => item.id === id);
    // console.log(config);
    if (config) {
      // if (!checkTimeRange(config)) {
      //   // console.log('时间不在范围内，不显示banner');
      //   return;
      // }
    } else {
      removeLocal(STORAGE_KEY.CARTX_BANNER);
      // console.log('未找到配置，删除本地存储');
      return;
    }

    let bannerDIV = document.createElement('div');
    bannerDIV.classList.add('localBanner');
    bannerDIV.innerHTML = sanitizeHtml(cartxBanner);

    if ([shopify[994], ...HELLOICE, ...AOOLIA, ...DRAW].includes(companyUUID)) {
      // 屏蔽banner展示
      const handelPageChange = () => {
        // 侧边栏排除购物车结账
        let hostname = window?.location?.hostname;
        let pathname = window?.location?.pathname;
        let paramseters = window?.location?.search;
        // prettier-ignore
        const includeUrls = [
          { url: '*/checkout/*' },
          { url: '*/cart/*' }
        ];
        if (matchUrlParts(pathname, hostname, paramseters, includeUrls)) {
          bannerDIV.style.display = 'none';
        } else {
          bannerDIV.style.display = '';
        }
        document?.body?.appendChild(bannerDIV);
      };
      const debounceHandelPageChange = debounce(handelPageChange, 300);

      // 默认执行一次
      handelPageChange();
      window.addEventListener('cartx/page/change', debounceHandelPageChange);
    } else {
      document?.body?.appendChild(bannerDIV);
    }

    if (
      isCommonSimpleOrTest()
    ) {
      const bar = window.CARTSEE_SUBSCRIBE?.config?.bar;
      const cartxBanner = document.querySelector('.cartx-banner');
      const { top } = window.getComputedStyle(cartxBanner);
      if (bar?.preventStyle === false && top === '0px') {
        // 实现paddingTop动画
        document.body.style.transition = 'padding-top 0.3s ease';
        document.body.style.paddingTop = `${cartxBanner.clientHeight}px`;
        document.body.setAttribute('data-cartx-banner-show', 'true');
      }
    }

    const countDown = document.querySelector('.cartx-a-banner-countdown');
    if (countDown) {
      const generateTime = (num) => {
        if (Number(num) < 10) {
          return `0${num}`;
        } else {
          return `${num}`;
        }
      };
      const tips = () => {
        const min = document.querySelector('.cartx-banner-min');
        const sec = document.querySelector('.cartx-banner-sec');
        if (!min && !sec) {
          // 啥都没有
          return;
        }
        const minNum = Number((min as any)?.innerText || 0);
        const secNum = Number((sec as any)?.innerText || 0);
        let secRes = secNum;
        let minRes = minNum;

        let needTips = true;
        if (secNum > 0) {
          secRes = secNum - 1;
        } else if (secNum === 0) {
          if (minNum > 0) {
            minRes = minNum - 1;
            secRes = 59;
          } else if (minNum === 0) {
            needTips = false;
          }
        }
        min && ((min as any).innerText = generateTime(minRes));
        sec && ((sec as any).innerText = generateTime(secRes));

        const localBanner = document.querySelector('.localBanner');
        setLocal(STORAGE_KEY.CARTX_BANNER, localBanner?.innerHTML ?? '');

        if (needTips) {
          setTimeout(() => {
            tips();
          }, 1000);
        }
      };
      setTimeout(() => {
        tips();
      }, 1000);
    }

    let observer = null;
    document.querySelector('.cartx-banner .cartx-banner-close')?.addEventListener('click', function () {
      if (
        isCommonSimpleOrTest()
      ) {
        if (document.body.getAttribute('data-cartx-banner-show') === 'true') {
          document.body.removeAttribute('data-cartx-banner-show');
          document.body.style.animation = '';
          document.body.style.paddingTop = '';
        }
      }

      document.body.removeChild(document.querySelector('.cartx-banner').parentNode);
      removeLocal(STORAGE_KEY.CARTX_BANNER);
      observer && observer.disconnect && observer.disconnect();
      observer = null;
    });

    const isTopBanner = () => {
      const banner: any = document.getElementsByClassName('cartx-banner');
      return banner && banner.length > 0 && banner[0]?.style?.top === '0px';
    };

    // 加购按钮监听 / 只针对底部弹窗
    if (
      isXikeOrTest() &&
      [xike[482], xike[313]].includes(companyUUID)
    ) {
      const config = { attributes: true, childList: true, subtree: true };
      const callback = function (mutationsList, observer) {
        if (isTopBanner()) {
          return;
        }
        for (let mutation of mutationsList) {
          if (mutation.target && mutation.target.classList) {
            // 商品
            if ([...mutation.target.classList].includes('product-detail__add-cart-wrap') || [...mutation.target.classList].includes('product-detail__cart-options')) {
              const targets: any = document.getElementsByClassName('product-detail__add-cart-wrap');
              if (targets && targets.length > 0) {
                const target = targets[targets.length - 1];
                if (Number(`${(target as any).style.opacity}`) !== 0 || (target as any).style.opacity === '') {
                  // 显示
                  let height = `${target.clientHeight || 0}`;
                  if (!height.includes('px')) {
                    height = height + 'px';
                  }
                  const banner: any = document.getElementsByClassName('cartx-banner');
                  if (banner && banner.length > 0) {
                    banner[0].style.bottom = height;
                  }
                } else {
                  // 隐藏
                  const banner: any = document.getElementsByClassName('cartx-banner');
                  if (banner && banner.length > 0) {
                    banner[0].style.bottom = '0px';
                  }
                }
              }
            }

            // 购物车
            let height = null;
            if (
              [...mutation.target.classList].includes('components-ajax-cart-total') ||
              [...mutation.target.classList].includes('components-ajax-cart-total__checkout') ||
              [...mutation.target.classList].includes('components-ajax-cart-total__sale-price') ||
              [...mutation.target.classList].includes('components-nav-bar__edit-show')
            ) {
              const targets = document.getElementsByClassName('components-ajax-cart-total');
              if (targets && targets.length > 0) {
                const target = targets[0];
                // 显示
                if (Number(`${target.clientHeight}`) > 0) {
                  height = `${target.clientHeight || 0}`;
                }
              } else {
                height = '0';
              }
            }

            // 编辑购物车
            if ([...mutation.target.classList].includes('components-ajax-cart-bottom-edit-bar')) {
              const targets = document.getElementsByClassName('components-ajax-cart-bottom-edit-bar');
              if (targets && targets.length > 0) {
                const target = targets[0];
                // 显示
                if (Number(`${target.clientHeight}`) > 0) {
                  height = `${target.clientHeight || 0}`;
                }
              }
            }
            if (height) {
              if (!height.includes('px')) {
                height = height + 'px';
              }
              const banner: any = document.getElementsByClassName('cartx-banner');
              if (banner && banner.length > 0) {
                banner[0].style.bottom = height;
              }
            }

            if (window?.location?.href && window?.location?.href.includes('checkout/payment-method')) {
              const targets = document.getElementsByClassName('total-bottom-address');
              if (targets && targets.length > 0) {
                const target = targets[0];
                if (window?.getComputedStyle(target)?.position === 'fixed') {
                  // 显示
                  let height = `${target.clientHeight || 0}`;
                  if (!height.includes('px')) {
                    height = height + 'px';
                  }
                  const banner: any = document.getElementsByClassName('cartx-banner');
                  if (banner && banner.length > 0) {
                    banner[0].style.bottom = height;
                  }
                } else {
                  const banner: any = document.getElementsByClassName('cartx-banner');
                  if (banner && banner.length > 0) {
                    banner[0].style.bottom = '0px';
                  }
                }
              } else {
                const banner: any = document.getElementsByClassName('cartx-banner');
                if (banner && banner.length > 0) {
                  banner[0].style.bottom = '0px';
                }
              }
            }
          }
        }
      };
      if (!!MutationObserver) {
        observer = new MutationObserver(callback);
      }
      observer && observer.observe && observer.observe(document.body, config);
      let timer = setTimeout(() => {
        const banner: any = document.getElementsByClassName('cartx-banner');
        if (banner && banner.length > 0) {
          banner[0].style.zIndex = 49;
        }

        if (isTopBanner()) {
          clearTimeout(timer);
          return '只适配上方弹窗';
        }

        let bottom: any = 0;
        const cartPageButton = document.getElementsByClassName('components-ajax-cart-total');
        if (cartPageButton && cartPageButton.length > 0) {
          let height = `${cartPageButton[0].clientHeight || 0}`;
          bottom = height;
          if (!height.includes('px')) {
            height = height + 'px';
          }
          const banner: any = document.getElementsByClassName('cartx-banner');
          if (banner && banner.length > 0) {
            banner[0].style.bottom = height;
          }
        }
        const editBar = document.getElementsByClassName('components-ajax-cart-bottom-edit-bar');
        if (editBar && editBar.length > 0) {
          let height = `${editBar[0].clientHeight || 0}`;
          bottom = height;
          if (!height.includes('px')) {
            height = height + 'px';
          }
          const banner: any = document.getElementsByClassName('cartx-banner');
          if (banner && banner.length > 0) {
            banner[0].style.bottom = height;
          }
        }
        const addCartWrap = document.getElementsByClassName('product-detail__add-cart-wrap');
        if (addCartWrap && addCartWrap.length > 0) {
          let height = `${addCartWrap[addCartWrap.length - 1].clientHeight || 0}`;
          bottom = height;
          if (!height.includes('px')) {
            height = height + 'px';
          }
          const banner: any = document.getElementsByClassName('cartx-banner');
          if (banner && banner.length > 0) {
            banner[0].style.bottom = height;
          }
        }
        if (window?.location?.href && window?.location?.href.includes('checkout/payment-method')) {
          const saveAddress = document.getElementsByClassName('total-bottom-address');
          if (saveAddress && saveAddress.length > 0) {
            if (window?.getComputedStyle(saveAddress[0])?.position === 'fixed') {
              let height = `${saveAddress[0].clientHeight || 0}`;
              bottom = height;
              if (!height.includes('px')) {
                height = height + 'px';
              }
              const banner: any = document.getElementsByClassName('cartx-banner');
              if (banner && banner.length > 0) {
                banner[0].style.bottom = height;
              }
            } else {
              const banner: any = document.getElementsByClassName('cartx-banner');
              if (banner && banner.length > 0) {
                banner[0].style.bottom = '0px';
              }
            }
          }
        }

        if (!`${bottom}`.includes('px')) {
          const banner: any = document.getElementsByClassName('cartx-banner');
          if (banner && banner.length > 0) {
            banner[0].style.bottom = bottom + 'px';
          }
        } else {
          const banner: any = document.getElementsByClassName('cartx-banner');
          if (banner && banner.length > 0) {
            banner[0].style.bottom = bottom;
          }
        }
      }, 100);
    }
  }

  let cartxFloatBanner = getLocal(STORAGE_KEY.CARTX_FLOAT_BANNER);
  let floatBanner = document.querySelector('.cartx-float-bar-wrapper');
  // 11月13日，https://u60z777w08.feishu.cn/docx/BfE5dvNA9omAQPx5j7vcxlMtnTc 浮条添加开关，450需要默认开启
  // 11月3日，公司450、313关闭浮窗展示，移动端正常显示
  // https://u60z777w08.feishu.cn/docx/BfE5dvNA9omAQPx5j7vcxlMtnTc 450浮窗显示
  // if (cartxFloatBanner && (companyUUID === 'lgoitpiz') && terminal) {
  //     // 有本地存储的float也删掉q
  //     window?.localStorage?.removeItem('cartx-float-bar-wrapper');
  //     window?.localStorage?.removeItem('cartx-float-bar-wrapper-data');
  //     cartxFloatBanner = undefined;
  // }
  if (cartxFloatBanner && !floatBanner) {
    let bannerDIV = document.createElement('div');
    bannerDIV.classList.add('localFloatBanner');
    bannerDIV.innerHTML = sanitizeHtml(cartxFloatBanner);
    document?.body?.appendChild(bannerDIV);

    document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-pack-up')?.addEventListener('click', function () {
      // console.log('收起');
      try {
        const floatBarData = getLocal(STORAGE_KEY.CARTX_FLOAT_BANNER_DATA);
        let data = {};
        if (floatBarData && typeof floatBarData === 'string' && floatBarData.length > 0) {
          data = JSON.parse(floatBarData) || {};
        }
        const { type, formId, name } = data as any;
        formEventV2({
          event: 'codefloat_hide',
          triggerEventType: type,
          formId: formId,
          formName: name
        })
          .then((response) => {
            // console.log('数据上报成功')
          })
          .catch((e) => catchLog('showBanner', e));
      } catch (error) { catchLog('showBanner', error); }

      (document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-icon') as any).style.display = '';
      (document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar') as any).style.display = 'none';
      setLocal(STORAGE_KEY.CARTX_FLOAT_BANNER, document.querySelector('.localFloatBanner').innerHTML);
    });

    document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-icon')?.addEventListener('click', function () {
      // console.log('显示');
      try {
        const floatBarData = getLocal(STORAGE_KEY.CARTX_FLOAT_BANNER_DATA);
        let data = {};
        if (floatBarData && typeof floatBarData === 'string' && floatBarData.length > 0) {
          data = JSON.parse(floatBarData) || {};
        }
        const { type, formId, name } = data as any;
        formEventV2({
          event: 'codefloat_view',
          triggerEventType: type,
          formId: formId,
          formName: name
        })
          .then((response) => {
            // console.log('数据上报成功')
          })
          .catch((e) => catchLog('showBanner', e));
      } catch (error) { catchLog('showBanner', error); }
      (document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-icon') as any).style.display = 'none';
      (document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar') as any).style.display = '';
      setLocal(STORAGE_KEY.CARTX_FLOAT_BANNER, document.querySelector('.localFloatBanner').innerHTML);
    });

    document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-copy')?.addEventListener('click', function () {
      // console.log('复制');
      try {
        const floatBarData = getLocal(STORAGE_KEY.CARTX_FLOAT_BANNER_DATA);
        let data = {};
        if (floatBarData && typeof floatBarData === 'string' && floatBarData.length > 0) {
          data = JSON.parse(floatBarData) || {};
        }
        const { type, formId, name } = data as any;
        formEventV2({
          event: 'codefloat_copy',
          triggerEventType: type,
          formId: formId,
          formName: name
        })
          .then((response) => {
            // console.log('数据上报成功')
          })
          .catch((e) => catchLog('showBanner', e));
      } catch (error) { catchLog('showBanner', error); }
      let copy: any = document.querySelector('.localFloatBanner .cartx-a-message-copy');
      copy.style.display = '';
      const el = document.createElement('textarea');
      el.value = (document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-code') as any).innerText.split(':')[1];
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document?.body?.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setTimeout(function () {
        copy.style.display = 'none';
      }, 1000);
    });

    document.querySelector('.cartx-float-bar-wrapper .cartx-float-bar-close')?.addEventListener('click', function () {
      // console.log('关闭');
      try {
        const floatBarData = getLocal(STORAGE_KEY.CARTX_FLOAT_BANNER_DATA);
        let data = {};
        if (floatBarData && typeof floatBarData === 'string' && floatBarData.length > 0) {
          data = JSON.parse(floatBarData) || {};
        }
        const { type, formId, name } = data as any;
        formEventV2({
          event: 'codefloat_close',
          triggerEventType: type,
          formId: formId,
          formName: name
        })
          .then((response) => {
            // console.log('数据上报成功')
          })
          .catch((e) => catchLog('showBanner', e));
      } catch (error) { catchLog('showBanner', error); }
      document.body.removeChild(document.querySelector('.cartx-float-bar-wrapper').parentNode);
      removeLocal(STORAGE_KEY.CARTX_FLOAT_BANNER);
      removeLocal(STORAGE_KEY.CARTX_FLOAT_BANNER_DATA);
    });
  }
}
